import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/Articles1.png';

const Article1 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          How to Choose the Right Tutor in Vadodara
        </h2>

        <div className="rsh-published-badge">
      Published on: 01 January 2026
        </div>

        <img src={blog1} alt="Tutor in Vadodara" className="rsh-blog-detail-img" />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Choosing the right tutor in Vadodara is one of the most important
            academic decisions parents can make. With increasing competition,
            board exams, and entrance tests, students need personalized guidance
            that goes beyond classroom teaching.
          </p>

          <p>
            Vadodara has some of Gujarat’s best schools and colleges, but every
            student learns differently. A professional home tutor or online
            tutor helps bridge learning gaps, boosts confidence, and improves
            academic performance.
          </p>

          {/* SECTION */}
          <div className="info-box">
            <h3>Understand the Student’s Academic Needs</h3>
            <p>
              Before selecting a tutor, parents must clearly identify what kind
              of support the student requires. This ensures better results and
              avoids unnecessary expenses.
            </p>
            <ul>
              <li>Exam preparation and syllabus completion</li>
              <li>Homework support and doubt clearing</li>
              <li>Concept clarity in weak subjects</li>
              <li>Competitive exam preparation (JEE, NEET, etc.)</li>
            </ul>
          </div>

          <div className="info-box">
            <h3>Check Tutor Qualifications & Experience</h3>
            <p>
              An experienced tutor understands student psychology and adapts
              teaching methods accordingly.
            </p>
            <ul>
              <li>Strong academic background</li>
              <li>Experience with CBSE, ICSE, and Gujarat Board</li>
              <li>Positive reviews from Vadodara parents</li>
            </ul>
          </div>

          <div className="info-box">
            <h3>Teaching Style & Compatibility</h3>
            <p>
              A tutor’s teaching style should match the student’s learning
              pattern. A demo class is highly recommended before finalizing.
            </p>
          </div>

          {/* TABLE 1 */}
          <h3 className="table-title">
            Home Tuition vs Coaching Institute in Vadodara
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Coaching Institute</th>
                  <th>Home Tuition</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Personal Attention</td>
                  <td>Low (20–50 students)</td>
                  <td>High (1-on-1 or small group)</td>
                </tr>
                <tr>
                  <td>Flexibility</td>
                  <td>Fixed schedule</td>
                  <td>Customizable timings</td>
                </tr>
                <tr>
                  <td>Environment</td>
                  <td>Classroom-style</td>
                  <td>Comfortable home setup</td>
                </tr>
                <tr>
                  <td>Learning Speed</td>
                  <td>Uniform pace</td>
                  <td>Student-paced learning</td>
                </tr>
                <tr>
                  <td>Focus</td>
                  <td>Divided attention</td>
                  <td>Full focus on student</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* TABLE 2 */}
          <h3 className="table-title">
            Average Tuition Fee Range in Vadodara (Per Month)
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Class / Exam</th>
                  <th>Home Tuition (₹)</th>
                  <th>Coaching Institute (₹)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Class 6–8</td>
                  <td>2,000 – 5,000</td>
                  <td>1,500 – 4,000</td>
                </tr>
                <tr>
                  <td>Class 9–10</td>
                  <td>3,000 – 6,000</td>
                  <td>2,000 – 5,000</td>
                </tr>
                <tr>
                  <td>Class 11–12 (Science)</td>
                  <td>4,000 – 10,000</td>
                  <td>3,000 – 8,000</td>
                </tr>
                <tr>
                  <td>JEE / NEET</td>
                  <td>8,000 – 20,000</td>
                  <td>6,000 – 18,000</td>
                </tr>
                <tr>
                  <td>Spoken English / IELTS</td>
                  <td>6,000 – 12,000</td>
                  <td>5,000 – 10,000</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="info-box">
            <h3>Final Verdict</h3>
            <p>
              Home tuition in Vadodara is ideal for students who need
              personalized attention and flexible schedules, while coaching
              institutes suit students comfortable with group learning.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button className="rsh-back-btn" onClick={() => history.push('/index')}>
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article1;